import { IoClose } from 'react-icons/io5';

interface FileUploadCardProps {
  fileName: string;
  progress: number;
  onClose?: () => void;
}

const CircularProgress = ({ progress }: { progress: number }) => {
  const radius = 15;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div className="relative w-8 h-8">
      <svg className="absolute transform -rotate-90" width="32" height="32">
        <circle
          cx="16"
          cy="16"
          r={radius}
          stroke="rgba(255,255,255,0.2)"
          strokeWidth="2"
          fill="none"
        />
        <circle
          cx="16"
          cy="16"
          r={radius}
          stroke="white"
          strokeWidth="2"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className="transition-all duration-300"
        />
      </svg>
      <span className="absolute inset-0 flex items-center justify-center text-[10px] text-white">
        {progress}%
      </span>
    </div>
  );
};

const FileUploadCard = ({ fileName, progress, onClose }: FileUploadCardProps) => {
  return (
    <div className="mb-2 bg-white rounded-lg p-2 text-black shadow-sm relative max-w-[350px]">
      {onClose && (
        <button 
          onClick={onClose}
          className="absolute -top-2 -right-2 text-gray-400 hover:text-gray-600 bg-white rounded-full p-0.5"
        >
          <IoClose size={16} />
        </button>
      )}
      <div className="flex items-center">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-[#0078d4] rounded-lg flex items-center justify-center relative">
            {progress < 100 ? (
              <CircularProgress progress={progress} />
            ) : (
              <span className="text-sm text-white">PDF</span>
            )}
          </div>
          <div className="flex-1 min-w-0 max-w-[250px]">
            <p className="text-sm font-medium truncate">{fileName}</p>
            <p className="text-xs text-gray-500">PDF</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUploadCard; 